/**
 * ANALYTICS WEB CLIENT EVENTS
 */
// those events are going to the analytics web client
export const UI_EVENT_TYPE = 'UI' as const;
export const TRACK_EVENT_TYPE = 'TRACK' as const;
export const SCREEN_EVENT_TYPE = 'SCREEN' as const;
export const OPERATIONAL_EVENT_TYPE = 'OPERATIONAL' as const;
/**
 * END ANALYTICS WEB CLIENT EVENTS
 */

export const PAGE_EVENT_ACTION = 'page-view' as const;

const SCREEN = 'Screen' as const;
const DRAWER = 'Drawer' as const;
const MODAL = 'Modal' as const;
const INLINE_DIALOG = 'InlineDialog' as const;
const DROPDOWN = 'Dropdown' as const;

export const ScreenTypes = {
	SCREEN,
	MODAL,
	DRAWER,
	INLINE_DIALOG,
	DROPDOWN,
} as const;
